module.exports = __webpack_public_path__ + "assets/build.afff0ba4.svg";